<template>
	<div class="sqlTextBox">
		<sf-input-group
			class="h-100"
			inputType="textarea"
			:inputValue="contentText"
			:labelSpan="0"
			labelPosition="left"
			:onChange="value => onChange(value)"
			placeholder="textarea"
		/>
	</div>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';

export default {
	props: {
		contentText: { type: String, default: '' }
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChange(value) {
			this.$emit('changeText', value);
		}
	}
};
</script>
<style lang="scss">
.sqlTextBox {
	height: 100%;
}
.sqlTextBox .sf-input-group-wrapper .el-row {
	height: 100% !important;
}
.sqlTextBox .sf-input-group-wrapper .el-row .el-col {
	height: 100% !important;
}
.sqlTextBox .sf-input-group-wrapper .el-row .el-col .el-textarea {
	height: 100% !important;
}
.sqlTextBox .sf-input-group-wrapper .el-row .el-col .el-textarea .el-textarea__inner {
	height: 100% !important;
}
</style>
